import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import { routerLinks } from "../../hoc/Router/routerLinks";
import LegalEntityList from "../../components/LegalEntity/List/LegalEntityList";
import { LEGAL_ENTITY_LIST } from "../../hoc/Router/routerTypes";

const LegalEntityListPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp
        items={[
          {
            title: "لیست افرادحقوقی",
            to: routerLinks(LEGAL_ENTITY_LIST),
          },
        ]}
      />

      <Grid container={true}>
        <Grid item xs={12}>
          <LegalEntityList />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default LegalEntityListPage;
